import React from 'react';
import { useEffect } from 'react';
import ReactModal from 'react-modal';
import { MODAL_ANIMATION_DURATION, ZIndex } from '../common';

interface IProps {
  isOpen: boolean;
  onRequestClose: () => void;
  contentStyle?: object;
  children: React.ReactNode;
  shouldCloseOnOverlayClick?: boolean;
}

export default function Modal({
  children,
  isOpen,
  onRequestClose,
  contentStyle,
  shouldCloseOnOverlayClick = true,
}: IProps) {
  const style = {
    overlay: OVERLAY_STYLE,
    content: contentStyle,
  };
  useEffect(() => {
    const handleTouchMove = (e: TouchEvent) => {
      if (isOpen) {
        e.preventDefault();
      }
    };
    window.addEventListener('touchmove', handleTouchMove);
    return () => {
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, [isOpen]);
  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel={'PodoModal'}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      onRequestClose={onRequestClose}
      closeTimeoutMS={MODAL_ANIMATION_DURATION}
      style={style}
    >
      {children}
    </ReactModal>
  );
}

ReactModal.setAppElement('#root');

const OVERLAY_STYLE = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: ZIndex.Modal,
};
